// src/components/kuestion/kb/kbShots.js
//
// Every screenshot an article can show, imported so the bundler fingerprints
// them and a missing file fails the build instead of a page. Keyed by the
// filename the article data uses. All captures share one viewport, so one
// aspect ratio holds for every figure.
import shot_addStudentPassword from '../../../assets/images/kuestion/kb/add-student-password.png';
import shot_addStudent from '../../../assets/images/kuestion/kb/add-student.png';
import shot_aiPrompt from '../../../assets/images/kuestion/kb/ai-prompt.png';
import shot_andAiPrompt from '../../../assets/images/kuestion/kb/and-ai-prompt.png';
import shot_andBanks from '../../../assets/images/kuestion/kb/and-banks.png';
import shot_andLoginSigninTab from '../../../assets/images/kuestion/kb/and-login-signin-tab.png';
import shot_andLoginStudent from '../../../assets/images/kuestion/kb/and-login-student.png';
import shot_andReceipt from '../../../assets/images/kuestion/kb/and-receipt.png';
import shot_andReview from '../../../assets/images/kuestion/kb/and-review.png';
import shot_andRunner from '../../../assets/images/kuestion/kb/and-runner.png';
import shot_andSoloHome from '../../../assets/images/kuestion/kb/and-solo-home.png';
import shot_andStrengths from '../../../assets/images/kuestion/kb/and-strengths.png';
import shot_andStudentHome from '../../../assets/images/kuestion/kb/and-student-home.png';
import shot_andTemplateEditor from '../../../assets/images/kuestion/kb/and-template-editor.png';
import shot_andTemplates from '../../../assets/images/kuestion/kb/and-templates.png';
import shot_assignmentBuilder from '../../../assets/images/kuestion/kb/assignment-builder.png';
import shot_assignmentList from '../../../assets/images/kuestion/kb/assignment-list.png';
import shot_billing from '../../../assets/images/kuestion/kb/billing.png';
import shot_cohortAnalytics from '../../../assets/images/kuestion/kb/cohort-analytics.png';
import shot_csvImportErrors from '../../../assets/images/kuestion/kb/csv-import-errors.png';
import shot_dashboard from '../../../assets/images/kuestion/kb/dashboard.png';
import shot_modeWizard from '../../../assets/images/kuestion/kb/mode-wizard.png';
import shot_orgWizard from '../../../assets/images/kuestion/kb/org-wizard.png';
import shot_passMark from '../../../assets/images/kuestion/kb/pass-mark.png';
import shot_roster from '../../../assets/images/kuestion/kb/roster.png';
import shot_studentReport from '../../../assets/images/kuestion/kb/student-report.png';
import shot_templateEditor from '../../../assets/images/kuestion/kb/template-editor.png';

export const SHOT_RATIO = '909 / 540';

const SHOTS = {
  'add-student-password.png': shot_addStudentPassword,
  'add-student.png': shot_addStudent,
  'ai-prompt.png': shot_aiPrompt,
  'and-ai-prompt.png': shot_andAiPrompt,
  'and-banks.png': shot_andBanks,
  'and-login-signin-tab.png': shot_andLoginSigninTab,
  'and-login-student.png': shot_andLoginStudent,
  'and-receipt.png': shot_andReceipt,
  'and-review.png': shot_andReview,
  'and-runner.png': shot_andRunner,
  'and-solo-home.png': shot_andSoloHome,
  'and-strengths.png': shot_andStrengths,
  'and-student-home.png': shot_andStudentHome,
  'and-template-editor.png': shot_andTemplateEditor,
  'and-templates.png': shot_andTemplates,
  'assignment-builder.png': shot_assignmentBuilder,
  'assignment-list.png': shot_assignmentList,
  'billing.png': shot_billing,
  'cohort-analytics.png': shot_cohortAnalytics,
  'csv-import-errors.png': shot_csvImportErrors,
  'dashboard.png': shot_dashboard,
  'mode-wizard.png': shot_modeWizard,
  'org-wizard.png': shot_orgWizard,
  'pass-mark.png': shot_passMark,
  'roster.png': shot_roster,
  'student-report.png': shot_studentReport,
  'template-editor.png': shot_templateEditor,
};

export default SHOTS;
